<template>
    <div>
        <b-container fluid class="mt-2 license-management-page">
            <b-row>
                <b-col cols="" class="px-1 px-sm-3">
                    <div class="expiry-data d-flex justify-content-between align-items-center mb-4">
                        <h2 class="text-left">{{ $t('aiChat.title') }}</h2>
                    </div>
                    <div class="ai-dbp-chat-container bg-white table-custom-border">
                        <!-- The thread's own shape while it loads, rather than the
                             app-wide spinner over an empty panel. -->
                        <div class="chat-dpb-messages" v-if="historyLoading">
                            <div v-for="n in 3" :key="`history-skeleton-${n}`" class="message-wrapper">
                                <!-- The question and its answer, in the bubbles they
                                     will actually arrive in. -->
                                <div class="message user-message skeleton-row my-4">
                                    <div class="message-avatar">
                                        <b-skeleton type="avatar" class="skeleton-avatar"></b-skeleton>
                                    </div>
                                    <div class="message-content user-content skeleton-bubble skeleton-bubble--user">
                                        <b-skeleton width="70%" class="mb-0"></b-skeleton>
                                    </div>
                                </div>
                                <div class="message ai-message skeleton-row">
                                    <b-skeleton type="avatar" class="skeleton-avatar"></b-skeleton>
                                    <div class="message-content ai-content skeleton-bubble">
                                        <b-skeleton width="95%"></b-skeleton>
                                        <b-skeleton width="80%"></b-skeleton>
                                        <b-skeleton width="55%" class="mb-0"></b-skeleton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="welcome-message" v-else-if="messages.length === 0">
                            <div>
                                <svg class="ai-avatar d-block mx-auto" width="40" height="40" viewBox="0 0 40 40"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                                        fill="#2D69F6" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M16.7587 14H23.2413C24.0463 14 24.7106 14 25.2518 14.0442C25.8139 14.0901 26.3306 14.1887 26.816 14.436C27.5686 14.8195 28.1805 15.4314 28.564 16.184C28.8113 16.6694 28.9099 17.1861 28.9558 17.7482C29 18.2894 29 18.9537 29 19.7587V24.2413C29 25.0463 29 25.7106 28.9558 26.2518C28.9099 26.8139 28.8113 27.3306 28.564 27.816C28.1805 28.5686 27.5686 29.1805 26.816 29.564C26.3306 29.8113 25.8139 29.9099 25.2518 29.9558C24.7106 30 24.0463 30 23.2413 30H16.7587C15.9537 30 15.2894 30 14.7482 29.9558C14.1861 29.9099 13.6694 29.8113 13.184 29.564C12.4314 29.1805 11.8195 28.5686 11.436 27.816C11.1887 27.3306 11.0901 26.8139 11.0442 26.2518C11 25.7106 11 25.0463 11 24.2413V19.7587C11 18.9537 11 18.2894 11.0442 17.7482C11.0901 17.1861 11.1887 16.6694 11.436 16.184C11.8195 15.4314 12.4314 14.8195 13.184 14.436C13.6694 14.1887 14.1861 14.0901 14.7482 14.0442C15.2894 14 15.9537 14 16.7587 14ZM14.911 16.0376C14.4726 16.0734 14.2484 16.1383 14.092 16.218C13.7157 16.4097 13.4097 16.7157 13.218 17.092C13.1383 17.2484 13.0734 17.4726 13.0376 17.911C13.0008 18.3611 13 18.9434 13 19.8V24.2C13 25.0566 13.0008 25.6389 13.0376 26.089C13.0734 26.5274 13.1383 26.7516 13.218 26.908C13.4097 27.2843 13.7157 27.5903 14.092 27.782C14.2484 27.8617 14.4726 27.9266 14.911 27.9624C15.3611 27.9992 15.9434 28 16.8 28H23.2C24.0566 28 24.6389 27.9992 25.089 27.9624C25.5274 27.9266 25.7516 27.8617 25.908 27.782C26.2843 27.5903 26.5903 27.2843 26.782 26.908C26.8617 26.7516 26.9266 26.5274 26.9625 26.089C26.9992 25.6389 27 25.0566 27 24.2V19.8C27 18.9434 26.9992 18.3611 26.9625 17.911C26.9266 17.4726 26.8617 17.2484 26.782 17.092C26.5903 16.7157 26.2843 16.4097 25.908 16.218C25.7516 16.1383 25.5274 16.0734 25.089 16.0376C24.6389 16.0008 24.0566 16 23.2 16H16.8C15.9434 16 15.3611 16.0008 14.911 16.0376Z"
                                        fill="white" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M18 11.43L18 12.0001L16 11.9999L16.0001 10.598L16.2783 10.3079C16.5208 10.055 16.8825 9.68715 17.5149 9.41279C18.1265 9.14744 18.9151 9 20 9C21.085 9 21.8736 9.14745 22.4852 9.41281C23.1175 9.68718 23.4793 10.055 23.7218 10.3079L24 10.598V12H22V11.43C21.9115 11.3609 21.8144 11.3019 21.6891 11.2475C21.4093 11.1261 20.9151 11 20 11C19.085 11 18.5908 11.1261 18.3109 11.2475C18.1856 11.3019 18.0886 11.3609 18 11.43Z"
                                        fill="white" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M20.0005 26C18.8097 26.0006 17.5934 25.695 16.4 24.8L17.6 23.2C18.4066 23.805 19.1886 24.0004 19.9995 24C20.8103 23.9996 21.594 23.8045 22.4 23.2L23.6 24.8C22.406 25.6955 21.1879 25.9994 20.0005 26Z"
                                        fill="white" />
                                    <path
                                        d="M15 20.5C15 19.6716 15.6716 19 16.5 19C17.3284 19 18 19.6716 18 20.5C18 21.3284 17.3284 22 16.5 22C15.6716 22 15 21.3284 15 20.5Z"
                                        fill="white" />
                                    <path
                                        d="M22 20.5C22 19.6716 22.6716 19 23.5 19C24.3284 19 25 19.6716 25 20.5C25 21.3284 24.3284 22 23.5 22C22.6716 22 22 21.3284 22 20.5Z"
                                        fill="white" />
                                </svg>
                                <p class="f-20 mt-2 text-center mb-0">{{ $t('aiChat.welcome') }}</p>
                            </div>
                        </div>
                        <div class="chat-dpb-messages" v-else ref="messageContainer">
                            <div v-for="(message, index) in messages" :key="index" class="message-wrapper">
                                <div v-if="message.type === 'user'" class="message user-message my-4">
                                    <div class="message-avatar">
                                        <b-img v-if="user.team_member && user.team_member.profile_picture"
                                            class="userSmallImage border-none h-40px w-40px rounded-circle"
                                            :src="user.team_member.profile_picture"></b-img>
                                        <div v-else class="user-default-img h-40px w-40px">
                                            {{ user.first_name.charAt(0).toUpperCase() }}{{
                                                user.last_name.charAt(0).toUpperCase() }}
                                        </div>
                                    </div>
                                    <div class="message-content user-content">
                                        {{ message.text }}
                                    </div>
                                </div>
                                <div v-else class="message ai-message">
                                    <svg class="ai-avatar" width="40" height="40" viewBox="0 0 40 40" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                                            fill="#2D69F6" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M16.7587 14H23.2413C24.0463 14 24.7106 14 25.2518 14.0442C25.8139 14.0901 26.3306 14.1887 26.816 14.436C27.5686 14.8195 28.1805 15.4314 28.564 16.184C28.8113 16.6694 28.9099 17.1861 28.9558 17.7482C29 18.2894 29 18.9537 29 19.7587V24.2413C29 25.0463 29 25.7106 28.9558 26.2518C28.9099 26.8139 28.8113 27.3306 28.564 27.816C28.1805 28.5686 27.5686 29.1805 26.816 29.564C26.3306 29.8113 25.8139 29.9099 25.2518 29.9558C24.7106 30 24.0463 30 23.2413 30H16.7587C15.9537 30 15.2894 30 14.7482 29.9558C14.1861 29.9099 13.6694 29.8113 13.184 29.564C12.4314 29.1805 11.8195 28.5686 11.436 27.816C11.1887 27.3306 11.0901 26.8139 11.0442 26.2518C11 25.7106 11 25.0463 11 24.2413V19.7587C11 18.9537 11 18.2894 11.0442 17.7482C11.0901 17.1861 11.1887 16.6694 11.436 16.184C11.8195 15.4314 12.4314 14.8195 13.184 14.436C13.6694 14.1887 14.1861 14.0901 14.7482 14.0442C15.2894 14 15.9537 14 16.7587 14ZM14.911 16.0376C14.4726 16.0734 14.2484 16.1383 14.092 16.218C13.7157 16.4097 13.4097 16.7157 13.218 17.092C13.1383 17.2484 13.0734 17.4726 13.0376 17.911C13.0008 18.3611 13 18.9434 13 19.8V24.2C13 25.0566 13.0008 25.6389 13.0376 26.089C13.0734 26.5274 13.1383 26.7516 13.218 26.908C13.4097 27.2843 13.7157 27.5903 14.092 27.782C14.2484 27.8617 14.4726 27.9266 14.911 27.9624C15.3611 27.9992 15.9434 28 16.8 28H23.2C24.0566 28 24.6389 27.9992 25.089 27.9624C25.5274 27.9266 25.7516 27.8617 25.908 27.782C26.2843 27.5903 26.5903 27.2843 26.782 26.908C26.8617 26.7516 26.9266 26.5274 26.9625 26.089C26.9992 25.6389 27 25.0566 27 24.2V19.8C27 18.9434 26.9992 18.3611 26.9625 17.911C26.9266 17.4726 26.8617 17.2484 26.782 17.092C26.5903 16.7157 26.2843 16.4097 25.908 16.218C25.7516 16.1383 25.5274 16.0734 25.089 16.0376C24.6389 16.0008 24.0566 16 23.2 16H16.8C15.9434 16 15.3611 16.0008 14.911 16.0376Z"
                                            fill="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M18 11.43L18 12.0001L16 11.9999L16.0001 10.598L16.2783 10.3079C16.5208 10.055 16.8825 9.68715 17.5149 9.41279C18.1265 9.14744 18.9151 9 20 9C21.085 9 21.8736 9.14745 22.4852 9.41281C23.1175 9.68718 23.4793 10.055 23.7218 10.3079L24 10.598V12H22V11.43C21.9115 11.3609 21.8144 11.3019 21.6891 11.2475C21.4093 11.1261 20.9151 11 20 11C19.085 11 18.5908 11.1261 18.3109 11.2475C18.1856 11.3019 18.0886 11.3609 18 11.43Z"
                                            fill="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M20.0005 26C18.8097 26.0006 17.5934 25.695 16.4 24.8L17.6 23.2C18.4066 23.805 19.1886 24.0004 19.9995 24C20.8103 23.9996 21.594 23.8045 22.4 23.2L23.6 24.8C22.406 25.6955 21.1879 25.9994 20.0005 26Z"
                                            fill="white" />
                                        <path
                                            d="M15 20.5C15 19.6716 15.6716 19 16.5 19C17.3284 19 18 19.6716 18 20.5C18 21.3284 17.3284 22 16.5 22C15.6716 22 15 21.3284 15 20.5Z"
                                            fill="white" />
                                        <path
                                            d="M22 20.5C22 19.6716 22.6716 19 23.5 19C24.3284 19 25 19.6716 25 20.5C25 21.3284 24.3284 22 23.5 22C22.6716 22 22 21.3284 22 20.5Z"
                                            fill="white" />
                                    </svg>

                                    <div class="message-content ai-content">
                                        <div v-if="message.isTyping" class="typing-text">
                                            <span v-html="message.displayText"></span>
                                            <span class="typing-cursor">|</span>
                                        </div>
                                        <div v-else>
                                            <div v-html="message.displayText"></div>
                                            <div v-if="message && message.sources && message.sources.length"
                                                class="sources-container mt-2">
                                                <div v-for="(source, srcIndex) in groupedSources(message.sources)"
                                                    :key="srcIndex" class="mt-2 source-item d-flex align-items-center">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8 4.66667V14" stroke="#6B7280" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M1.99992 12C1.82311 12 1.65354 11.9298 1.52851 11.8047C1.40349 11.6797 1.33325 11.5101 1.33325 11.3333V2.66667C1.33325 2.48986 1.40349 2.32029 1.52851 2.19526C1.65354 2.07024 1.82311 2 1.99992 2H5.33325C6.0405 2 6.71877 2.28095 7.21887 2.78105C7.71897 3.28115 7.99992 3.95942 7.99992 4.66667C7.99992 3.95942 8.28087 3.28115 8.78097 2.78105C9.28106 2.28095 9.95934 2 10.6666 2H13.9999C14.1767 2 14.3463 2.07024 14.4713 2.19526C14.5963 2.32029 14.6666 2.48986 14.6666 2.66667V11.3333C14.6666 11.5101 14.5963 11.6797 14.4713 11.8047C14.3463 11.9298 14.1767 12 13.9999 12H9.99992C9.46949 12 8.96078 12.2107 8.58571 12.5858C8.21063 12.9609 7.99992 13.4696 7.99992 14C7.99992 13.4696 7.78921 12.9609 7.41413 12.5858C7.03906 12.2107 6.53035 12 5.99992 12H1.99992Z"
                                                            stroke="#6B7280" stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <p class="mb-0 f-12 ml-2 text-grey-200">
                                                        {{ source.document_title }}<template v-if="source.pages.length">, {{
                                                            $t('aiChat.sourcePages', { pages: source.pages.join(', ') })
                                                        }}</template>
                                                    </p>

                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div v-if="isAiTyping" class="message ai-message">
                                <svg class="ai-avatar" width="40" height="40" viewBox="0 0 40 40" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                                        fill="#2D69F6" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M16.7587 14H23.2413C24.0463 14 24.7106 14 25.2518 14.0442C25.8139 14.0901 26.3306 14.1887 26.816 14.436C27.5686 14.8195 28.1805 15.4314 28.564 16.184C28.8113 16.6694 28.9099 17.1861 28.9558 17.7482C29 18.2894 29 18.9537 29 19.7587V24.2413C29 25.0463 29 25.7106 28.9558 26.2518C28.9099 26.8139 28.8113 27.3306 28.564 27.816C28.1805 28.5686 27.5686 29.1805 26.816 29.564C26.3306 29.8113 25.8139 29.9099 25.2518 29.9558C24.7106 30 24.0463 30 23.2413 30H16.7587C15.9537 30 15.2894 30 14.7482 29.9558C14.1861 29.9099 13.6694 29.8113 13.184 29.564C12.4314 29.1805 11.8195 28.5686 11.436 27.816C11.1887 27.3306 11.0901 26.8139 11.0442 26.2518C11 25.7106 11 25.0463 11 24.2413V19.7587C11 18.9537 11 18.2894 11.0442 17.7482C11.0901 17.1861 11.1887 16.6694 11.436 16.184C11.8195 15.4314 12.4314 14.8195 13.184 14.436C13.6694 14.1887 14.1861 14.0901 14.7482 14.0442C15.2894 14 15.9537 14 16.7587 14ZM14.911 16.0376C14.4726 16.0734 14.2484 16.1383 14.092 16.218C13.7157 16.4097 13.4097 16.7157 13.218 17.092C13.1383 17.2484 13.0734 17.4726 13.0376 17.911C13.0008 18.3611 13 18.9434 13 19.8V24.2C13 25.0566 13.0008 25.6389 13.0376 26.089C13.0734 26.5274 13.1383 26.7516 13.218 26.908C13.4097 27.2843 13.7157 27.5903 14.092 27.782C14.2484 27.8617 14.4726 27.9266 14.911 27.9624C15.3611 27.9992 15.9434 28 16.8 28H23.2C24.0566 28 24.6389 27.9992 25.089 27.9624C25.5274 27.9266 25.7516 27.8617 25.908 27.782C26.2843 27.5903 26.5903 27.2843 26.782 26.908C26.8617 26.7516 26.9266 26.5274 26.9625 26.089C26.9992 25.6389 27 25.0566 27 24.2V19.8C27 18.9434 26.9992 18.3611 26.9625 17.911C26.9266 17.4726 26.8617 17.2484 26.782 17.092C26.5903 16.7157 26.2843 16.4097 25.908 16.218C25.7516 16.1383 25.5274 16.0734 25.089 16.0376C24.6389 16.0008 24.0566 16 23.2 16H16.8C15.9434 16 15.3611 16.0008 14.911 16.0376Z"
                                        fill="white" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M18 11.43L18 12.0001L16 11.9999L16.0001 10.598L16.2783 10.3079C16.5208 10.055 16.8825 9.68715 17.5149 9.41279C18.1265 9.14744 18.9151 9 20 9C21.085 9 21.8736 9.14745 22.4852 9.41281C23.1175 9.68718 23.4793 10.055 23.7218 10.3079L24 10.598V12H22V11.43C21.9115 11.3609 21.8144 11.3019 21.6891 11.2475C21.4093 11.1261 20.9151 11 20 11C19.085 11 18.5908 11.1261 18.3109 11.2475C18.1856 11.3019 18.0886 11.3609 18 11.43Z"
                                        fill="white" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M20.0005 26C18.8097 26.0006 17.5934 25.695 16.4 24.8L17.6 23.2C18.4066 23.805 19.1886 24.0004 19.9995 24C20.8103 23.9996 21.594 23.8045 22.4 23.2L23.6 24.8C22.406 25.6955 21.1879 25.9994 20.0005 26Z"
                                        fill="white" />
                                    <path
                                        d="M15 20.5C15 19.6716 15.6716 19 16.5 19C17.3284 19 18 19.6716 18 20.5C18 21.3284 17.3284 22 16.5 22C15.6716 22 15 21.3284 15 20.5Z"
                                        fill="white" />
                                    <path
                                        d="M22 20.5C22 19.6716 22.6716 19 23.5 19C24.3284 19 25 19.6716 25 20.5C25 21.3284 24.3284 22 23.5 22C22.6716 22 22 21.3284 22 20.5Z"
                                        fill="white" />
                                </svg>
                                <div class="message-content ai-content">
                                    <div class="typing-indicator">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="chat-input-area">
                            <div class="input-container">
                                <div class="input-wrapper">
                                    <textarea v-model="newMessage" @keydown.enter="handleEnter" @keydown="handleKeydown"
                                        @input="adjustTextareaHeight" ref="messageInput"
                                        :placeholder="$t('aiChat.placeholder')" class="message-input" rows="1"
                                        :disabled="isAiTyping || isListening"></textarea>

                                    <!-- Voice Recognition Button -->
                                    <button @click="toggleVoiceRecognition" :disabled="isAiTyping"
                                        :class="['voice-button', { 'listening': isListening, 'not-supported': !speechSupported }]"
                                        v-if="speechSupported"
                                        :title="isListening ? $t('aiChat.stopListening') : $t('aiChat.startVoiceInput')"
                                        :aria-label="isListening ? $t('aiChat.stopVoiceRecognition') : $t('aiChat.startVoiceRecognition')"
                                        role="button">
                                        <svg v-if="!isListening" width="36" height="36" viewBox="0 0 26 26" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13 1C19.6311 1 25 6.33333 25 13C25 19.6667 19.6311 25 13 25C6.36889 25 1 19.6667 1 13C1 6.33333 6.36889 1 13 1Z"
                                                stroke="black" stroke-opacity="0.1" stroke-width="0.543863" />
                                            <path
                                                d="M13.4429 15.8857C14.1537 15.8857 14.8291 15.6188 15.3267 15.0857C15.8243 14.6414 16.1086 13.9309 16.1086 13.22V9.66571C16.1086 8.95486 15.8243 8.24435 15.3267 7.80006C14.8291 7.26692 14.1537 7 13.4429 7C12.732 7 12.0566 7.26692 11.559 7.80006C11.0614 8.24435 10.7771 8.95486 10.7771 9.66571V13.22C10.7771 13.9309 11.0614 14.6414 11.559 15.0857C12.0566 15.6188 12.732 15.8857 13.4429 15.8857ZM11.6657 9.66571C11.6657 9.22143 11.8522 8.7768 12.1898 8.42137C12.5186 8.06594 12.9719 7.88857 13.4429 7.88857C13.9138 7.88857 14.3671 8.06594 14.6959 8.42137C15.0335 8.7768 15.22 9.22143 15.22 9.66571V13.22C15.22 13.6643 15.0335 14.1089 14.6959 14.4643C14.3671 14.8198 13.9138 14.9971 13.4429 14.9971C12.9719 14.9971 12.5186 14.8198 12.1898 14.4643C11.8522 14.1089 11.6657 13.6643 11.6657 13.22V9.66571ZM13.8871 17.6629V18.9957C13.8871 19.0846 13.8428 19.2626 13.7539 19.3515C13.674 19.3515 13.5584 19.44 13.4429 19.44C13.3273 19.44 13.2117 19.3515 13.1318 19.3515C13.0429 19.2626 12.9986 19.0846 12.9986 18.9957V17.6629C11.9056 17.4851 10.8838 17.0412 10.1463 16.2415C9.40878 15.3529 9 14.2863 9 13.22C9 13.1311 9.04434 12.9531 9.1332 12.8642C9.21317 12.8642 9.32877 12.7757 9.44429 12.7757C9.5598 12.7757 9.6754 12.8642 9.75537 12.8642C9.84423 12.9531 9.88857 13.1311 9.88857 13.22C9.88857 14.1974 10.2617 15.0858 10.9281 15.7078C11.5946 16.4187 12.501 16.7743 13.4429 16.7743C14.3847 16.7743 15.2912 16.4187 15.9576 15.7078C16.624 15.0858 16.9971 14.1974 16.9971 13.22C16.9971 13.1311 17.0415 12.9531 17.1303 12.8642C17.2103 12.8642 17.3259 12.7757 17.4414 12.7757C17.5569 12.7757 17.6725 12.8642 17.7525 12.8642C17.8414 12.9531 17.8857 13.1311 17.8857 13.22C17.8857 14.2863 17.4769 15.3529 16.7394 16.2415C16.0019 17.0412 14.9801 17.4851 13.8871 17.6629Z"
                                                fill="black" />
                                        </svg>

                                        <svg v-else width="36" height="36" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0 12C0 5.37273 5.37273 0 12 0C18.6273 0 24 5.37273 24 12C24 18.6273 18.6273 24 12 24C5.37273 24 0 18.6273 0 12Z"
                                                fill="black" fill-opacity="0.04" />
                                            <path
                                                d="M9.77714 12.22V8.66571C9.77714 7.95486 10.0569 7.28834 10.559 6.79963C11.0566 6.26648 11.7364 6 12.4429 6C13.1493 6 13.8291 6.26648 14.3267 6.79963C14.8288 7.28834 15.1086 7.95486 15.1086 8.66571V12.22C15.1086 12.9309 14.8288 13.5974 14.3267 14.0861C13.8291 14.6192 13.1493 14.8857 12.4429 14.8857C11.7364 14.8857 11.0566 14.6192 10.559 14.0861C10.0569 13.5974 9.77714 12.9309 9.77714 12.22ZM16.8857 12.22C16.8857 12.0867 16.8368 11.9978 16.7569 11.9089C16.6724 11.8201 16.5614 11.7757 16.4414 11.7757C16.3215 11.7757 16.2104 11.8201 16.126 11.9089C16.046 11.9978 15.9971 12.0867 15.9971 12.22C15.9971 13.153 15.624 14.0861 14.9576 14.7525C14.2912 15.4189 13.3847 15.7743 12.4429 15.7743C11.501 15.7743 10.5946 15.4189 9.92813 14.7525C9.2617 14.0861 8.88857 13.153 8.88857 12.22C8.88857 12.0867 8.83968 11.9978 8.75971 11.9089C8.6753 11.8201 8.56424 11.7757 8.44429 11.7757C8.32433 11.7757 8.21327 11.8201 8.12886 11.9089C8.04889 11.9978 8 12.0867 8 12.22C8 13.3307 8.40867 14.3971 9.15063 15.1968C9.88814 15.9965 10.9012 16.5296 11.9986 16.6629V17.9957C11.9986 18.129 12.0475 18.2179 12.1274 18.3068C12.2118 18.3957 12.3229 18.44 12.4429 18.44C12.5628 18.44 12.6739 18.3957 12.7583 18.3068C12.8383 18.2179 12.8871 18.129 12.8871 17.9957V16.6629C13.9845 16.5296 14.9976 15.9965 15.7351 15.1968C16.477 14.3971 16.8857 13.3307 16.8857 12.22Z"
                                                fill="black" />
                                        </svg>

                                    </button>

                                    <button @click="sendMessage" :disabled="!newMessage.trim() || isAiTyping || isListening"
                                        class="send-button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                            class="bi bi-send" viewBox="0 0 16 16">
                                            <path
                                                d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z">
                                            </path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { marked } from 'marked';
export default {
    name: 'AIChat',
    data() {
        return {
            messages: [],
            // The first read of the thread; the skeleton stands in for it.
            historyLoading: true,
            newMessage: '',
            isAiTyping: false,
            // Voice recognition properties
            speechSupported: false,
            isListening: false,
            voiceTranscript: '',
            voiceError: '',
            recognition: null
        }
    },
    computed: {
        ...mapGetters(['user', 'company']),
        getAICredits(){
            return this.company[0]?.ai_credits || 0
        },
    },
    methods: {
        ...mapActions(['setLoader', 'generateAIChat', 'streamAIChat', 'getAIChatHistory', 'setNotification']),
        // What was asked and answered before, so the thread carries on rather
        // than starting blank every visit.
        async loadHistory() {
            this.historyLoading = true;
            try {
                const data = await this.getAIChatHistory(15);
                const rows = Array.isArray(data) ? data : (data && (data.results || data.data)) || [];
                const ordered = [...rows].sort(
                    (a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0)
                );
                const restored = [];
                ordered.forEach((row) => {
                    if (!row) return;
                    const asked = row.query || row.question || row.message;
                    const answered = row.answer || row.response;
                    const timestamp = row.created_at ? new Date(row.created_at) : new Date();
                    if (asked) restored.push({ type: 'user', text: asked, timestamp });
                    if (answered) {
                        restored.push({
                            type: 'ai',
                            text: answered,
                            sources: row.sources || [],
                            displayText: marked.parse(answered),
                            isTyping: false,
                            timestamp,
                        });
                    }
                });
                if (restored.length) {
                    this.messages = restored;
                    this.$nextTick(() => this.scrollToBottom());
                }
            } catch (error) {
                // An empty thread is a fine fallback; the welcome screen stays.
                console.error('Error loading chat history:', error);
            } finally {
                this.historyLoading = false;
            }
        },
        async sendMessage() {
            if (this.getAICredits <= 0) {
                 this.setNotification({
                    msg: this.$t('recordsAndTotal.noAICredits'),
                    type: "error",
                    color: "red",
                });
                return;
            }
            if (!this.newMessage.trim() || this.isAiTyping) return;

            // Add user message
            const userMessage = {
                type: 'user',
                text: this.newMessage.trim(),
                timestamp: new Date()
            };
            this.messages.push(userMessage);

            // Clear input
            const messageText = this.newMessage.trim();
            this.newMessage = '';
            this.adjustTextareaHeight();

            // Scroll to bottom
            this.$nextTick(() => {
                this.scrollToBottom();
            });

            // Show typing indicator immediately
            this.isAiTyping = true;

            // Call AI response (no artificial delay - wait for real API)
            this.simulateAiResponse(messageText);
        },

        // The same document comes back once per page it was found on; they read
        // as one line with its pages listed.
        groupedSources(sources) {
            const grouped = [];
            (sources || []).forEach((source) => {
                if (!source) return;
                const title = source.document_title || "";
                let entry = grouped.find((item) => item.document_title === title);
                if (!entry) {
                    entry = { document_title: title, pages: [] };
                    grouped.push(entry);
                }
                const page = source.page_number;
                if (page !== null && page !== undefined && !entry.pages.includes(page)) entry.pages.push(page);
            });
            grouped.forEach((entry) => entry.pages.sort((a, b) => a - b));
            return grouped;
        },
        async simulateAiResponse(userMessage) {
            // Keep typing indicator showing while we wait for API
            // this.isAiTyping = false; // Remove this line - keep it true

            try {
                // The answer streams back a token at a time, so the message goes
                // in empty and grows as the events arrive.
                let aiMessage = null;
                const appendToken = (token) => {
                    if (!token) return;
                    if (!aiMessage) {
                        // The first token is also what ends the typing dots.
                        this.isAiTyping = false;
                        this.$nextTick(() => {
                            if (this.$refs.messageInput) this.$refs.messageInput.focus();
                        });
                        aiMessage = {
                            type: 'ai',
                            text: '',
                            sources: [],
                            displayText: '',
                            isTyping: true,
                            timestamp: new Date()
                        };
                        this.messages.push(aiMessage);
                    }
                    aiMessage.text += token;
                    aiMessage.displayText = marked.parse(aiMessage.text);
                    this.$nextTick(() => this.scrollToBottom());
                };

                await this.streamAIChat({
                    payload: { query: userMessage, limit: 5 },
                    onEvent: (event) => {
                        if (!event || !event.type) return;
                        if (event.type === 'token') appendToken(event.text);
                        else if (event.type === 'sources' && aiMessage) aiMessage.sources = event.sources || [];
                        else if (event.type === 'error') throw { data: { error: event.error || event.message } };
                    }
                });

                // Nothing streamed at all: say something rather than nothing.
                if (!aiMessage) appendToken(this.$t('aiChat.fallbackResponse'));
                aiMessage.isTyping = false;
                this.isAiTyping = false;

            } catch (error) {
                if (error && error.data && error.data.error) {
                    await this.setNotification({
                        msg: error.data.error,
                        type: "error",
                        color: "red",
                    });
                    this.isAiTyping = false;
                }
                else {

                    this.isAiTyping = false;

                    // Fallback to dummy response on error
                    const fallbackText = this.$t('aiChat.errorResponse');

                    const aiMessage = {
                        type: 'ai',
                        text: fallbackText,
                        sources: [],
                        displayText: '',
                        isTyping: true,
                        timestamp: new Date()
                    };
                    this.messages.push(aiMessage);

                    // Scroll to bottom
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });

                    // Start typewriter effect
                    await this.typewriterEffect(this.messages.length - 1, fallbackText);
                }
            }
        },

        async typewriterEffect(messageIndex, fullText, isHtml = false) {
            const message = this.messages[messageIndex];
            const typingSpeed = 30;

            if (isHtml) {
                // For markdown HTML, just show it fully (no per-char typing)
                message.displayText = fullText;
                message.isTyping = false;
                this.$nextTick(() => this.scrollToBottom());
                return;
            }

            for (let i = 0; i <= fullText.length; i++) {
                message.displayText = fullText.substring(0, i);
                this.$nextTick(() => this.scrollToBottom());
                if (i < fullText.length) await new Promise(r => setTimeout(r, typingSpeed));
            }

            message.isTyping = false;
        },

        handleEnter(event) {
            if (event.shiftKey) {
                // Allow new line with Shift+Enter - don't prevent default
                // The textarea will handle adding the new line naturally
                this.$nextTick(() => {
                    this.adjustTextareaHeight();
                });
                return;
            }

            // Only send message if Enter is pressed without Shift
            event.preventDefault();
            this.sendMessage();
        },

        handleKeydown(event) {
            // Ctrl/Cmd + M for voice recognition toggle
            if ((event.ctrlKey || event.metaKey) && event.key === 'm') {
                event.preventDefault();
                this.toggleVoiceRecognition();
            }
        },

        adjustTextareaHeight() {
            this.$nextTick(() => {
                const textarea = this.$refs.messageInput;
                if (textarea) {
                    textarea.style.height = 'auto';
                    textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
                }
            });
        },

        scrollToBottom() {
            const chatMessages = this.$refs.messageContainer;
            if (chatMessages) {
                chatMessages.scrollTop = chatMessages.scrollHeight;
            }
        },

        // Voice Recognition Methods
        initSpeechRecognition() {
            // Check if speech recognition is supported
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

            if (!SpeechRecognition) {
                this.speechSupported = false;
                console.warn('Speech recognition not supported in this browser');
                return;
            }

            // Additional checks for secure context (HTTPS)
            if (!window.isSecureContext && location.protocol !== 'https:' && location.hostname !== 'localhost') {
                this.speechSupported = false;
                console.warn('Speech recognition requires HTTPS or localhost');
                return;
            }

            this.speechSupported = true;
            this.recognition = new SpeechRecognition();

            // Configure recognition
            this.recognition.continuous = false;
            this.recognition.interimResults = true;
            this.recognition.lang = navigator.language || 'en-US';
            this.recognition.maxAlternatives = 1;

            // Event handlers
            this.recognition.onstart = () => {
                this.isListening = true;
                this.voiceError = '';
                this.voiceTranscript = '';
            };

            this.recognition.onresult = (event) => {

                let interimTranscript = '';
                let finalTranscript = '';

                try {
                    for (let i = event.resultIndex; i < event.results.length; i++) {
                        const result = event.results[i];
                        const transcript = result[0].transcript;


                        if (result.isFinal) {
                            finalTranscript += transcript;
                        } else {
                            interimTranscript += transcript;
                        }
                    }

                    // Update the transcript display (show both interim and final)
                    const combinedTranscript = finalTranscript + interimTranscript;
                    this.voiceTranscript = combinedTranscript;

                    // If we have a final result, set it to the message input
                    if (finalTranscript.trim()) {
                        this.newMessage = finalTranscript.trim();
                        this.adjustTextareaHeight();
                    }
                } catch (error) {
                    console.error('Error processing speech recognition result:', error);
                }
            };

            this.recognition.onerror = (event) => {
                this.isListening = false;

                switch (event.error) {
                    case 'no-speech':
                        this.voiceError = this.$t('aiChat.noSpeech');
                        break;
                    case 'audio-capture':
                        this.voiceError = this.$t('aiChat.audioCapture');
                        break;
                    case 'not-allowed':
                        this.voiceError = this.$t('aiChat.notAllowed');
                        break;
                    case 'network':
                        this.voiceError = this.$t('aiChat.networkError');
                        break;
                    case 'service-not-allowed':
                        this.voiceError = this.$t('aiChat.serviceNotAllowed');
                        break;
                    case 'bad-grammar':
                        this.voiceError = this.$t('aiChat.badGrammar');
                        break;
                    case 'language-not-supported':
                        this.voiceError = this.$t('aiChat.languageNotSupported');
                        break;
                    default:
                        this.voiceError = this.$t('aiChat.genericRecognitionError', { error: event.error });
                }

                // Clear error after 5 seconds
                setTimeout(() => {
                    this.voiceError = '';
                }, 5000);
            };

            this.recognition.onend = () => {
                this.isListening = false;
                this.voiceTranscript = '';

                // Refocus on the input after voice recognition ends
                this.$nextTick(() => {
                    if (this.$refs.messageInput) {
                        this.$refs.messageInput.focus();
                    }
                });
            };
        },

        toggleVoiceRecognition() {
            if (!this.speechSupported) {
                this.voiceError = this.$t('aiChat.notSupported');
                setTimeout(() => {
                    this.voiceError = '';
                }, 3000);
                return;
            }

            if (this.isListening) {
                this.stopVoiceRecognition();
            } else {
                this.startVoiceRecognition();
            }
        },

        startVoiceRecognition() {
            if (!this.recognition || this.isAiTyping) {
                return;
            }

            try {
                this.voiceError = '';
                this.voiceTranscript = '';

                // Check microphone permissions before starting
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({ audio: true })
                        .then(() => {
                            this.recognition.start();
                        })
                        .catch((error) => {
                            console.error('Microphone access denied:', error);
                            this.voiceError = this.$t('aiChat.micRequired');
                            setTimeout(() => {
                                this.voiceError = '';
                            }, 5000);
                        });
                } else {
                    // Fallback for older browsers
                    this.recognition.start();
                }
            } catch (error) {
                console.error('Error starting voice recognition:', error);
                this.voiceError = this.$t('aiChat.startFailed');
                setTimeout(() => {
                    this.voiceError = '';
                }, 3000);
            }
        },

        stopVoiceRecognition() {
            if (this.recognition && this.isListening) {
                this.recognition.stop();
            }
        },

        // Debug method - call this from browser console to test speech recognition
        testSpeechRecognition() {
            if (!this.recognition) 
            return {
                speechSupported: this.speechSupported,
                isListening: this.isListening,
                recognition: this.recognition
            };
        },

        // Test microphone access
        async testMicrophone() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(track => track.stop());

                return { success: true, message: 'Microphone access granted' };
            } catch (error) {
                console.error('❌ Microphone access failed:', error);
                return { success: false, error: error.message };
            }
        }
    },
    watch: {
        messages() {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        isTyping(newVal) {
            if (newVal) {
                this.scrollToBottom();
            }
        },
    },
    destroyed() {
        const feedbackBtn = document.querySelector(".bb-feedback-button");
        if (feedbackBtn) {
            feedbackBtn.classList.remove("d-none");
        }
    },
    mounted() {
        // Focus on input when component mounts
        this.$nextTick(() => {
            if (this.$refs.messageInput) {
                this.$refs.messageInput.focus();
            }
        });

        this.loadHistory();

        // Initialize speech recognition
        this.initSpeechRecognition();

        // Add global keyboard event listener
        document.addEventListener('keydown', this.handleKeydown)
        const feedbackBtn = document.querySelector(".bb-feedback-button");
        if (feedbackBtn) {
            feedbackBtn.classList.add("d-none");
        }
    },
    beforeDestroy() {
        // Remove global keyboard event listener
        document.removeEventListener('keydown', this.handleKeydown);

        // Clean up speech recognition
        if (this.recognition) {
            this.recognition.onstart = null;
            this.recognition.onresult = null;
            this.recognition.onerror = null;
            this.recognition.onend = null;
            if (this.isListening) {
                this.recognition.stop();
            }
            this.recognition = null;
        }
    }
}; 
</script>

<style>
.ai-dbp-chat-container {
    height: calc(100vh - 150px);
    display: flex;
    flex-direction: column;
}

.ai-chat-container {
    position: fixed;
    top: 60px;
    left: 240px;
    /* same width as your sidebar */
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background: #f8f8f8;
    overflow: hidden;
}

/* Chat Header */
.chat-header {
    background: var(--btn-bg-color);
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.online-indicator {
    width: 8px;
    height: 8px;
    background: #2CCE89;
    border-radius: 50%;
    display: inline-block;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

/* Chat Messages Area */
.chat-messages {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    scroll-behavior: smooth;
    min-height: 0;
}

.chat-messages::-webkit-scrollbar {
    width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Welcome Message */
.welcome-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 0;
    text-align: center;
}

.chat-dpb-messages {
    flex: 1;
    min-height: 0;
    padding: 0rem 2rem;
    overflow: auto;
}

/* Standing in for the thread while it loads, in the bubbles it will hold: the
   real ones size to their text, so these are given a width to fill. */
.skeleton-avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    margin: 0;
}
/* `.message` carries margin-right: auto, which cancels stretch in this column
   flex — the real rows get their width from their text, a skeleton has none. */
.skeleton-row {
    width: 100%;
    margin-right: 0 !important;
}
.skeleton-bubble {
    flex: 1 1 auto;
    min-width: 0;
}
/* A question is a line, not a paragraph. */
.skeleton-bubble--user {
    max-width: 420px;
}

/* Message Wrapper */
.message-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

/* Individual Messages */
.message {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    max-width: 100%;
}

.user-message,
.ai-message {
    flex-direction: row;
    margin-right: auto;
}

/* Message Avatars */
.message-avatar {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    flex-shrink: 0;
    margin-top: 4px;
}

.ai-avatar {
    max-width: 40px;
    height: 40px;
    width: -webkit-fill-available;
}

/* Message Content */
.message-content {
    padding: 0.75rem 1rem;
    border-radius: 18px;
    word-wrap: break-word;
    line-height: 1.4;
    font-size: 14px;
    position: relative;
}

.user-content {
    border: 1px solid #F3F4F6;
    border-radius: 8px;
    padding: 1rem;
    font-size: 14px;
    text-align: left;
}

.ai-content {
    background: #F3F4F6;
    text-align: left;
    border: 1px solid #F3F4F6;
    padding: 1rem;
    border-radius: 8px;
    font-size: 14px;
    text-align: left;
}

/* Lists read like a document: numbers for ordered lists, filled bullets for the
   rest (nested ones too), indented when nested, with muted markers so the text leads. */
.ai-content>div ul,
.ai-content>div ol {
    padding-left: 1.5rem;
    margin-bottom: 0.75rem;
}
.ai-content>div ol > li >p,
.ai-content>div ul > li >p
{
 margin-bottom: 0.25rem;
}
.ai-content>div ol {
    list-style: decimal;
}

/* Nested lists default to hollow circles in the browser; keep them filled. */
.ai-content>div ul,
.ai-content>div ul ul,
.ai-content>div ol ul {
    list-style: disc;
}

.ai-content>div li {
    margin-bottom: 6px;
    padding-left: 4px;
}

.ai-content>div li::marker {
    color: #6B7280;
}

.ai-content>div li>ul,
.ai-content>div li>ol {
    margin-top: 6px;
    margin-bottom: 0;
}

.ai-content p:last-child {
    margin-bottom: 0;
}

/* Typing Effect */
.typing-text {
    position: relative;
}

.typing-cursor {
    display: inline-block;
    animation: blink 1s infinite;
    color: var(--btn-bg-color);
    font-weight: bold;
}

@keyframes blink {

    0%,
    50% {
        opacity: 1;
    }

    51%,
    100% {
        opacity: 0;
    }
}

/* Typing Indicator */
.typing-indicator {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 0;
}

.sources-container {
    border-top: 1px solid #E5E7EB;
}

.typing-indicator span {
    height: 8px;
    width: 8px;
    background: var(--btn-bg-color);
    border-radius: 50%;
    display: inline-block;
    animation: typing 1.4s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
    animation-delay: -0.32s;
}

.typing-indicator span:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes typing {

    0%,
    80%,
    100% {
        transform: scale(0.8);
        opacity: 0.5;
    }

    40% {
        transform: scale(1);
        opacity: 1;
    }
}

/* Input Area */
.chat-input-area {
    padding: 1rem 1.5rem 0rem 1.5rem;
    background: white;
    flex-shrink: 0;
    min-height: auto;
}

.input-container {
    width: 98%;
    margin: 0 auto;
}

.input-wrapper {
    display: flex;
    align-items: flex-end;
    gap: 0.75rem;
    border-top: 1px solid #e0e0e0;
    padding: 8px 1px;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.message-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    resize: none;
    font-size: 14px;
    line-height: 1.4;
    padding: 8px 0;
    min-height: 20px;
    max-height: 120px;
    overflow-y: auto;
    font-family: inherit;
}

.message-input::placeholder {
    color: #999;
}

.message-input::-webkit-scrollbar {
    width: 4px;
}

.message-input::-webkit-scrollbar-track {
    background: transparent;
}

.message-input::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
}

.send-button {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: var(--btn-bg-color);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.send-button:hover:not(:disabled) {
    background: #1e5ce6;
    transform: scale(1.05);
}

.send-button:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
}

.send-button:active:not(:disabled) {
    transform: scale(0.95);
}

/* Voice Recognition Styles */
.voice-button {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid #e0e0e0;
    background: white;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.voice-button:hover:not(:disabled) {
    border-color: var(--btn-bg-color);
    color: var(--btn-bg-color);
    transform: scale(1.05);
}

.voice-button.listening {
    animation: pulse-voice 1.5s infinite;
}

.voice-button.not-supported {
    opacity: 0.5;
    cursor: not-allowed;
}

.voice-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

@keyframes pulse-voice {
    0% {
        box-shadow: 0 0 0 0 rgba(45, 105, 246, 0.4);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(45, 105, 246, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(45, 105, 246, 0);
    }
}

.voice-status {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0;
    color: var(--btn-bg-color);
    font-size: 12px;
    border-top: 1px solid #f0f0f0;
    margin-top: 0.5rem;
}

.voice-indicator {
    display: flex;
    gap: 2px;
}

.voice-wave {
    width: 3px;
    height: 12px;
    background: var(--btn-bg-color);
    border-radius: 1px;
    animation: voice-wave 1s infinite ease-in-out;
}

.voice-wave:nth-child(1) {
    animation-delay: -0.4s;
}

.voice-wave:nth-child(2) {
    animation-delay: -0.2s;
}

.voice-wave:nth-child(3) {
    animation-delay: 0s;
}

@keyframes voice-wave {

    0%,
    40%,
    100% {
        transform: scaleY(0.4);
    }

    20% {
        transform: scaleY(1);
    }
}

.voice-text {
    flex: 1;
    font-weight: 500;
}

.voice-error {
    color: #e74c3c;
    font-size: 12px;
    padding: 0.5rem 0;
    border-top: 1px solid #f0f0f0;
    margin-top: 0.5rem;
}

.voice-not-supported {
    color: #f39c12;
    font-size: 12px;
    padding: 0.5rem 0;
    border-top: 1px solid #f0f0f0;
    margin-top: 0.5rem;
    text-align: center;
}

.voice-help {
    color: #6c757d;
    font-size: 11px;
    padding: 0.25rem 0;
    text-align: center;
    opacity: 0.8;
}

/* Responsive Design */
@media (max-width: 768px) {
    .chat-header {
        padding: 1rem;
    }

    .chat-messages {
        padding: 0.75rem;
    }

    .chat-input-area {
        padding: 1rem 1rem 0rem 1rem;
    }

    .user-message,
    .ai-message {
        max-width: 100%;
    }

    .message-content {
        font-size: 13px;
        padding: 0.6rem 0.8rem;
        width: -webkit-fill-available;
    }

    .message-avatar {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }
}

@media (max-width: 575px) {

    .message-avatar,
    .ai-avatar {
        display: none;
    }
}
</style>